import { isEmpty } from 'lodash';

import {
    REQUEST_FORM_SUBMIT_PAYMENT,
    SUCCESS_FORM_SUBMIT_PAYMENT,
    FAILURE_FORM_SUBMIT_PAYMENT,
    RESET_FORM_SUBMIT_PAYMENT,
    PAYMENT_REQUEST_TYPE_IBAN,
    PAYMENT_REQUEST_TYPE_ASSOCIATION,
    PAYMENT_REQUEST_TYPE_NURSURY,
    SET_TIMEOUT_ID,
    CLEAR_TIMEOUT_ID
} from './constants';

import { fetchPaymentRequestsIfNeeded } from '../ongoing/actions';

import { makeActionCreator } from '../../../../utils/actionsUtils';

import gtm from '../../../../utils/gtmUtils';
import { CALL_API } from '../../../../middlewares/api';

export const ERROR_FORMDATA_EMPTY = 'formData param must not be empty or null or undefined !';

export const reset = makeActionCreator(RESET_FORM_SUBMIT_PAYMENT);

export const setTimeoutId = makeActionCreator(SET_TIMEOUT_ID, 'timeoutId');
export const clearTimeoutId = makeActionCreator(CLEAR_TIMEOUT_ID);

export function sendPaymentRequest(type, formData, callback) {
    if (isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }

    let url;
    let paymentMethod;
    if (type === PAYMENT_REQUEST_TYPE_IBAN) {
        url = '/payment/iban';
        paymentMethod = 'iban';
    } else if (type === PAYMENT_REQUEST_TYPE_ASSOCIATION) {
        url = '/payment/association';
        paymentMethod = 'association';
    } else if (type === PAYMENT_REQUEST_TYPE_NURSURY) {
        url = '/payment/nursury';
        paymentMethod = 'nursery';
    } else {
        url = '/payment';
        paymentMethod = 'default';
    }

    return {
        [CALL_API]: {
            endpoint: url,
            types: [
                REQUEST_FORM_SUBMIT_PAYMENT,
                SUCCESS_FORM_SUBMIT_PAYMENT,
                FAILURE_FORM_SUBMIT_PAYMENT
            ],
            body: formData,
            successCallback: (response, dispatch) => {
                const requestedAmount = Number(String(formData.requestedAmount).replace(',', '.'));
                // value toujours poussée (null si montant illisible) : le dataLayer
                // fusionne les push, une clé omise garderait la valeur d'un événement
                // précédent de la même session SPA
                gtm.event('payment_request', {
                    payment_method: paymentMethod,
                    currency: 'EUR',
                    value: requestedAmount || null
                });

                dispatch(fetchPaymentRequestsIfNeeded(true));
                if (callback) {
                    callback();
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/request/actions.js